import React, { FC, useMemo } from 'react';
import { SelectProps } from 'formik-antd/src/select/index';
import { Select } from 'formik-antd';
import { useQuery } from 'react-query';
import { QueryKey } from 'api/queryKey';
import { fetchPersonalDocumentTypes } from 'api/personalDocumentAPI';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export enum PersonalDocument {
  Pesel = 'PESEL',
  Passport = 'PASSPORT',
  ResidentCard = 'RESIDENT_CARD',
  NonRequiredDocument = 'NON_REQUIRED',
}
const personalDocumentLabelMap = new Map<string, string>([
  [PersonalDocument.Pesel, 'personalDocument.Pesel'],
  [PersonalDocument.Passport, 'personalDocument.Passport'],
  [PersonalDocument.ResidentCard, 'personalDocument.ResidentCard'],
  [
    PersonalDocument.NonRequiredDocument,
    'personalDocument.NonRequiredDocument',
  ],
]);

export const PersonalDocumentTypeSelect: FC<SelectProps> = (props) => {
  const { isLoading, data } = useQuery(
    [QueryKey.BusinessPartnerPatient],
    () => {
      return fetchPersonalDocumentTypes();
    }
  );

  const intlMessage = useFormatMessage();

  const options = useMemo(
    () =>
      data?.map((x) => (
        <Select.Option key={x} value={x}>
          {intlMessage({ id: personalDocumentLabelMap.get(x) ?? x })}
        </Select.Option>
      )),
    [data, intlMessage]
  );

  return (
    <Select {...props} loading={isLoading}>
      {options}
    </Select>
  );
};
